import { Component, OnInit } from '@angular/core';
import { RouteService } from '../../services/route.service';
import { RoutePages } from 'src/app/enum/route-pages';
import { ApiUrlUtil } from 'src/app/util/api-url-util';

@Component({
  selector: 'app-redirect-suite',
  templateUrl: './redirect-suite.component.html'
})
export class RedirectSuiteComponent implements OnInit {

  constructor(private routeService: RouteService) {
  }

  ngOnInit() {
    if (!this.routeService.getCurrentRoute() || this.routeService.getCurrentRoute() == RoutePages.Suite) {
      ApiUrlUtil.goToSuiteRoot();
    }
  }

}
